import { Controller } from '@hotwired/stimulus';

/*
 * DDT-4046: hold back content that would otherwise become the page's LCP element on phones.
 *
 * On phones the login-page blog teasers are stacked under the login card and are the
 * largest contentful paint. Chrome stops recording LCP at the first scroll, tap or key
 * press, so below md the row ships hidden (`.jf-deferred-content`, see _custom.scss) with
 * placeholder images, and is shown only then. From md up the CSS leaves the row visible
 * and a <source> already serves the real pictures, so the row is marked shown straight
 * away: otherwise a phone loaded in landscape and then rotated to portrait would drop
 * below md with the row hidden and no listener left to reveal it.
 */
const EVENTS = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
const RENDERED_UP_FRONT = '(min-width: 768px)'; // Bootstrap md, as in _custom.scss

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['image'];

    connect() {
        // The controller is fetched lazily: the visitor may already have scrolled.
        if (window.matchMedia(RENDERED_UP_FRONT).matches || window.scrollY > 0) {
            this.show();

            return;
        }

        this.show = this.show.bind(this);
        EVENTS.forEach((event) => window.addEventListener(event, this.show, { once: true, passive: true }));
    }

    disconnect() {
        EVENTS.forEach((event) => window.removeEventListener(event, this.show));
    }

    show() {
        this.disconnect();
        this.imageTargets.forEach((image) => {
            image.src = image.dataset.src;
        });
        this.element.classList.add('is-shown');
    }
}
